import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { style: {"display":"flex","gap":"1rem","justify-content":"center","flex-wrap":"wrap","margin":"2rem 0 3rem"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "program-grid" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "program-grid" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "program-grid" }
const _hoisted_10 = { class: "modal-content" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { style: {"margin-top":"2rem"} }
const _hoisted_14 = { style: {"margin-top":"1.5rem","text-align":"center"} }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 3 }
const _hoisted_17 = { key: 4 }
const _hoisted_18 = { style: {"margin-top":"2rem"} }
const _hoisted_19 = { style: {"margin-top":"1.5rem","text-align":"center","display":"flex","gap":"1rem","justify-content":"center","flex-wrap":"wrap"} }
const _hoisted_20 = { key: 5 }
const _hoisted_21 = { key: 6 }
const _hoisted_22 = { key: 7 }
const _hoisted_23 = { key: 8 }
const _hoisted_24 = { key: 9 }
const _hoisted_25 = { style: {"margin-top":"2rem"} }
const _hoisted_26 = { class: "package-grid" }
const _hoisted_27 = { class: "package-grid" }
const _hoisted_28 = { class: "package-grid" }
const _hoisted_29 = { class: "package-grid" }
const _hoisted_30 = { class: "package-grid" }
const _hoisted_31 = { key: 10 }
const _hoisted_32 = { key: 11 }
const _hoisted_33 = { key: 12 }
const _hoisted_34 = { style: {"margin-top":"2rem"} }
const _hoisted_35 = { style: {"margin-top":"1.5rem","text-align":"center"} }

import { ref, onMounted, onUnmounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SupportCard from '@/components/SupportCard.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SupportView',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const currentSection = ref<'general' | 'mint' | 'zorin'>('general')
const activeModal = ref<string | null>(null)

const openModal = (modalName: string) => {
  activeModal.value = modalName
  document.body.style.overflow = 'hidden'
  updateURL()
}

const closeModal = () => {
  activeModal.value = null
  document.body.style.overflow = 'auto'
  updateURL()
}

const openExternal = (url: string) => {
  window.open(url, '_blank', 'noopener noreferrer')
}

// Update URL with query params
const updateURL = () => {
  const query: any = {}

  if (currentSection.value !== 'general') {
    query.section = currentSection.value
  }

  if (activeModal.value) {
    query.topic = activeModal.value
  }

  // Only update if query params changed
  if (JSON.stringify(route.query) !== JSON.stringify(query)) {
    router.replace({ query })
  }
}

// Watch for section changes
watch(currentSection, () => {
  updateURL()
})

// Initialize from URL params
const initializeFromURL = () => {
  // Read section from URL
  if (route.query.section) {
    const section = route.query.section as string
    if (section === 'general' || section === 'mint' || section === 'zorin') {
      currentSection.value = section
    }
  }

  // Read topic from URL
  if (route.query.topic) {
    const topic = route.query.topic as string
    activeModal.value = topic
    document.body.style.overflow = 'hidden'
  }
}

// Close modal on Escape key
const handleEscape = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    closeModal()
  }
}

onMounted(() => {
  document.addEventListener('keydown', handleEscape)
  initializeFromURL()
})

onUnmounted(() => {
  document.removeEventListener('keydown', handleEscape)
  document.body.style.overflow = 'auto'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _cache[133] || (_cache[133] = _createElementVNode("section", { class: "hero" }, [
      _createElementVNode("div", { class: "hero-content" }, [
        _createElementVNode("h2", null, "Support & Help"),
        _createElementVNode("p", null, "Resources for students and teachers using Space Coast STEM laptops")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[46] || (_cache[46] = _createElementVNode("h2", { style: {"text-align":"center"} }, "Help Topics", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (currentSection.value = 'general')),
            class: _normalizeClass(["btn btn-primary", { active: currentSection.value === 'general' }]),
            style: {"cursor":"pointer"}
          }, " General ", 2),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (currentSection.value = 'mint')),
            class: _normalizeClass(["btn btn-secondary", { active: currentSection.value === 'mint' }]),
            style: {"cursor":"pointer"}
          }, " Linux Mint ", 2),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (currentSection.value = 'zorin')),
            class: _normalizeClass(["btn btn-secondary", { active: currentSection.value === 'zorin' }]),
            style: {"cursor":"pointer"}
          }, " Zorin OS ", 2)
        ]),
        (currentSection.value === 'general')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[39] || (_cache[39] = _createElementVNode("h3", { style: {"text-align":"center","margin-bottom":"2rem"} }, "General Information", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(SupportCard, {
                  icon: "📋",
                  title: "Understanding Packing Slips",
                  description: "Learn about the performance ratings and specifications included with your laptop",
                  "action-text": "details",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (openModal('packingSlips')))
                })
              ]),
              _cache[40] || (_cache[40] = _createStaticVNode("<div class=\"info-box info\" style=\"margin-top:2rem;\" data-v-8e3e7e50><strong data-v-8e3e7e50>Which Linux am I using?</strong> Our laptops now ship with <strong data-v-8e3e7e50>Linux Mint (Xfce)</strong>. Laptops we handed out earlier run <strong data-v-8e3e7e50>Zorin OS</strong> and are still fully supported — pick the tab above that matches your desktop. Not sure which one you have? Open the <strong data-v-8e3e7e50>Menu</strong> and search for <strong data-v-8e3e7e50>System Information</strong> (Linux Mint) or <strong data-v-8e3e7e50>About</strong> (Zorin OS), or just email us and we&#39;ll help you figure it out. </div><div class=\"help-box\" data-v-8e3e7e50><h3 data-v-8e3e7e50>Need More Help?</h3><p data-v-8e3e7e50>If you can&#39;t find what you&#39;re looking for or need additional assistance, please contact us:</p><ul style=\"margin-top:1rem;\" data-v-8e3e7e50><li data-v-8e3e7e50><strong data-v-8e3e7e50>Email:</strong> <a href=\"mailto:info@spacecoaststem.org\" data-v-8e3e7e50>info@spacecoaststem.org</a></li><li data-v-8e3e7e50><strong data-v-8e3e7e50>Subject Line:</strong> Include &quot;Tech Support&quot; in your email subject</li><li data-v-8e3e7e50><strong data-v-8e3e7e50>Include:</strong> Your name, school, and a description of the issue</li></ul></div>", 2))
            ]))
          : _createCommentVNode("", true),
        (currentSection.value === 'mint')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[41] || (_cache[41] = _createElementVNode("h3", { style: {"text-align":"center","margin-bottom":"2rem"} }, "Common Tasks for Linux Mint (Xfce)", -1)),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(SupportCard, {
                  icon: "🚀",
                  title: "Getting Started with Linux Mint",
                  description: "First time using your laptop? Start here for setup and basics",
                  "action-text": "guide",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (openModal('mintGettingStarted')))
                }),
                _createVNode(SupportCard, {
                  icon: "🐧",
                  title: "Why We Use Linux",
                  description: "Learn why we install Linux on all our refurbished machines",
                  "action-text": "more",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (openModal('whyLinux')))
                }),
                _createVNode(SupportCard, {
                  icon: "🔧",
                  title: "Setting the Username",
                  description: "Learn how to change your username and display name",
                  "action-text": "steps",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (openModal('mintUsername')))
                }),
                _createVNode(SupportCard, {
                  icon: "📦",
                  title: "Installing Software",
                  description: "Install new applications using the Software Manager",
                  "action-text": "steps",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (openModal('mintInstallSoftware')))
                }),
                _createVNode(SupportCard, {
                  icon: "⭐",
                  title: "Popular Packages",
                  description: "Recommended free software for students and creative work",
                  "action-text": "browse",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (openModal('popularPackages')))
                }),
                _createVNode(SupportCard, {
                  icon: "🎮",
                  title: "Gaming on Linux",
                  description: "Learn about playing and developing games on your laptop",
                  "action-text": "explore",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (openModal('gaming')))
                }),
                _createVNode(SupportCard, {
                  icon: "📚",
                  title: "Other Questions",
                  description: "Visit the official Linux Mint documentation for more guides and tutorials",
                  "action-text": "linuxmint.com",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (openModal('mintOtherQuestions')))
                })
              ]),
              _cache[42] || (_cache[42] = _createStaticVNode("<div class=\"help-box\" data-v-8e3e7e50><h3 data-v-8e3e7e50>Need More Help?</h3><p data-v-8e3e7e50>If you can&#39;t find what you&#39;re looking for or need additional assistance, please contact us:</p><ul style=\"margin-top:1rem;\" data-v-8e3e7e50><li data-v-8e3e7e50><strong data-v-8e3e7e50>Email:</strong> <a href=\"mailto:info@spacecoaststem.org\" data-v-8e3e7e50>info@spacecoaststem.org</a></li><li data-v-8e3e7e50><strong data-v-8e3e7e50>Subject Line:</strong> Include &quot;Tech Support&quot; in your email subject</li><li data-v-8e3e7e50><strong data-v-8e3e7e50>Include:</strong> Your name, school, and a description of the issue</li></ul></div>", 1))
            ]))
          : _createCommentVNode("", true),
        (currentSection.value === 'zorin')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _cache[43] || (_cache[43] = _createElementVNode("h3", { style: {"text-align":"center","margin-bottom":"2rem"} }, "Common Tasks for Zorin OS", -1)),
              _cache[44] || (_cache[44] = _createElementVNode("div", {
                class: "info-box info",
                style: {"margin-bottom":"2rem"}
              }, [
                _createElementVNode("strong", null, "Still using Zorin OS?"),
                _createTextVNode(" No problem. New Space Coast STEM laptops now ship with "),
                _createElementVNode("strong", null, "Linux Mint (Xfce)"),
                _createTextVNode(", but every Zorin OS laptop we handed out is still fully supported and these guides are kept up to date. There's no need to switch — if you'd like to move to Linux Mint anyway, just "),
                _createElementVNode("a", { href: "mailto:info@spacecoaststem.org" }, "email us"),
                _createTextVNode(". ")
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(SupportCard, {
                  icon: "🚀",
                  title: "Getting Started with Zorin OS",
                  description: "First time using your laptop? Start here for setup and basics",
                  "action-text": "guide",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (openModal('gettingStarted')))
                }),
                _createVNode(SupportCard, {
                  icon: "🐧",
                  title: "Why We Use Linux",
                  description: "Learn why we install Linux on all our refurbished machines",
                  "action-text": "more",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (openModal('whyLinux')))
                }),
                _createVNode(SupportCard, {
                  icon: "🔧",
                  title: "Setting the Username",
                  description: "Learn how to change your username and display name",
                  "action-text": "steps",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (openModal('username')))
                }),
                _createVNode(SupportCard, {
                  icon: "👪",
                  title: "Adding a User for Parental Controls",
                  description: "Create a new user account with parental controls",
                  "action-text": "steps",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (openModal('parentalControl')))
                }),
                _createVNode(SupportCard, {
                  icon: "📦",
                  title: "Installing Software",
                  description: "Install new applications using the Software Center",
                  "action-text": "steps",
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (openModal('installSoftware')))
                }),
                _createVNode(SupportCard, {
                  icon: "⭐",
                  title: "Popular Packages",
                  description: "Recommended free software for students and creative work",
                  "action-text": "browse",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (openModal('popularPackages')))
                }),
                _createVNode(SupportCard, {
                  icon: "🎮",
                  title: "Gaming on Linux",
                  description: "Learn about playing and developing games on your laptop",
                  "action-text": "explore",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (openModal('gaming')))
                }),
                _createVNode(SupportCard, {
                  icon: "📚",
                  title: "Other Questions",
                  description: "Visit the official Zorin OS Help Center for more guides and tutorials",
                  "action-text": "help.zorin.com",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (openModal('otherQuestions')))
                })
              ]),
              _cache[45] || (_cache[45] = _createStaticVNode("<div class=\"help-box\" data-v-8e3e7e50><h3 data-v-8e3e7e50>Need More Help?</h3><p data-v-8e3e7e50>If you can&#39;t find what you&#39;re looking for or need additional assistance, please contact us:</p><ul style=\"margin-top:1rem;\" data-v-8e3e7e50><li data-v-8e3e7e50><strong data-v-8e3e7e50>Email:</strong> <a href=\"mailto:info@spacecoaststem.org\" data-v-8e3e7e50>info@spacecoaststem.org</a></li><li data-v-8e3e7e50><strong data-v-8e3e7e50>Subject Line:</strong> Include &quot;Tech Support&quot; in your email subject</li><li data-v-8e3e7e50><strong data-v-8e3e7e50>Include:</strong> Your name, school, and a description of the issue</li></ul></div>", 1))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (activeModal.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-overlay",
            onClick: _withModifiers(closeModal, ["self"])
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "modal-close",
                onClick: closeModal
              }, "×"),
              (activeModal.value === 'packingSlips')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[47] || (_cache[47] = _createElementVNode("h2", null, "Understanding Your Laptop's Packing Slip", -1)),
                    _cache[48] || (_cache[48] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Every laptop from Space Coast STEM comes with a packing slip that includes important information about your device.", -1)),
                    _cache[49] || (_cache[49] = _createElementVNode("div", { style: {"margin-top":"2rem","text-align":"center"} }, [
                      _createElementVNode("img", {
                        src: "/assets/img/packing_slip.png",
                        alt: "Example Packing Slip",
                        style: {"max-width":"100%","border":"2px solid #ddd","border-radius":"8px","box-shadow":"0 4px 6px rgba(0,0,0,0.1)"}
                      }),
                      _createElementVNode("p", { style: {"margin-top":"0.5rem","font-size":"0.9rem","color":"#666","font-style":"italic"} }, "Example of a laptop packing slip")
                    ], -1)),
                    _cache[50] || (_cache[50] = _createElementVNode("div", { style: {"margin-top":"2rem"} }, [
                      _createElementVNode("h3", null, "What's on the Packing Slip?"),
                      _createElementVNode("ul", { style: {"margin-top":"1rem"} }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Laptop Model:"),
                          _createTextVNode(" The brand and model name prominently displayed at the top")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Performance Rating:"),
                          _createTextVNode(" A 1-10 score with color-coded badge (yellow/orange for 1-3, green for 4-7, blue for 8-10)")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Screen Size:"),
                          _createTextVNode(" Display diagonal measurement in inches")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "CPU:"),
                          _createTextVNode(" Processor model (e.g., Intel Core i5, AMD Ryzen)")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "GPU:"),
                          _createTextVNode(" Graphics card (if present - important for creative work and gaming)")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "RAM:"),
                          _createTextVNode(" Memory capacity (4GB, 8GB, 16GB, etc.)")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Storage:"),
                          _createTextVNode(" Hard drive or SSD capacity")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Operating System:"),
                          _createTextVNode(" Usually Linux (Linux Mint on our current laptops, Zorin OS on older ones) or Windows")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Recommended For:"),
                          _createTextVNode(" List of suitable activities based on the rating and specs")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Special Notes:"),
                          _createTextVNode(" Any unique features or considerations")
                        ])
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Performance Rating Scale"),
                      _createElementVNode("p", { style: {"margin-top":"1rem"} }, "We rate each laptop on a 1-10 scale to help you understand what it can do:"),
                      _createElementVNode("p", null, "We have minimum requirements for the equipment we distribute, so a low rating does not mean that it is not a capable machine. It is just not meant for handling more demanding tasks. All of our laptops are suitable for basic educational activities."),
                      _createElementVNode("div", { class: "rating-visual" }),
                      _createElementVNode("div", { class: "rating-box basic" }, [
                        _createElementVNode("h4", null, "⭐ Rating 1-3: Basic Performance"),
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, "Best for:"),
                          _createTextVNode(" Basic homework, web browsing, email, word processing, and simple research")
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, "Examples:"),
                          _createTextVNode(" Writing essays, browsing educational websites, checking email, watching videos")
                        ])
                      ]),
                      _createElementVNode("div", { class: "rating-box standard" }, [
                        _createElementVNode("h4", null, "⭐⭐ Rating 4-7: Standard Performance"),
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, "Best for:"),
                          _createTextVNode(" More intense tasks, multi-tasking, presentations, light photo editing, and educational software")
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, "Examples:"),
                          _createTextVNode(" Running multiple programs at once, creating presentations, basic coding, light image editing, video conferencing")
                        ])
                      ]),
                      _createElementVNode("div", { class: "rating-box high" }, [
                        _createElementVNode("h4", null, "⭐⭐⭐ Rating 8-10: High Performance"),
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, "Best for:"),
                          _createTextVNode(" Demanding applications, creative work, programming, video editing, and specialized tasks")
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("strong", null, "Examples:"),
                          _createTextVNode(" Advanced coding projects, video/photo editing, 3D modeling, machine learning experiments, creative tools like GIMP or Blender")
                        ]),
                        _createElementVNode("p", null, [
                          _createElementVNode("em", null, "Note: Some laptops in this range include dedicated GPUs for graphics-intensive work")
                        ])
                      ])
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'mintGettingStarted')
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _cache[63] || (_cache[63] = _createElementVNode("h2", null, "Getting Started with Linux Mint", -1)),
                    _cache[64] || (_cache[64] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, [
                      _createTextVNode("Welcome to your new Space Coast STEM laptop! Your laptop runs "),
                      _createElementVNode("strong", null, "Linux Mint"),
                      _createTextVNode(" with the "),
                      _createElementVNode("strong", null, "Xfce"),
                      _createTextVNode(" desktop — a fast, lightweight desktop that keeps older hardware feeling quick. This guide will help you get started.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[52] || (_cache[52] = _createElementVNode("h3", null, "Default Login Credentials", -1)),
                      _cache[53] || (_cache[53] = _createElementVNode("div", { class: "info-box warning" }, [
                        _createElementVNode("p", { style: {"margin":"0","font-size":"1.1rem"} }, [
                          _createElementVNode("strong", null, "Username:"),
                          _createTextVNode(),
                          _createElementVNode("code", null, "user")
                        ]),
                        _createElementVNode("p", { style: {"margin":"0.5rem 0 0 0","font-size":"1.1rem"} }, [
                          _createElementVNode("strong", null, "Password:"),
                          _createTextVNode(),
                          _createElementVNode("code", null, "password")
                        ])
                      ], -1)),
                      _cache[54] || (_cache[54] = _createElementVNode("p", { style: {"margin-top":"1rem","font-style":"italic","color":"#666"} }, [
                        _createElementVNode("strong", null, "Important:"),
                        _createTextVNode(" For security, we recommend changing your username and password after your first login.")
                      ], -1)),
                      _cache[55] || (_cache[55] = _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Your Linux Mint Xfce Desktop", -1)),
                      _cache[56] || (_cache[56] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Everything lives on the panel along the bottom of the screen:", -1)),
                      _cache[57] || (_cache[57] = _createElementVNode("ul", { style: {"margin-top":"1rem"} }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Menu (bottom-left):"),
                          _createTextVNode(" Click the Linux Mint logo to open the menu. Start typing to search for any app or setting — this is the fastest way to find anything.")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Favorites & categories:"),
                          _createTextVNode(" The menu groups apps into categories (Office, Graphics, Internet, Administration), with your favorites pinned on the left.")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "System tray (bottom-right):"),
                          _createTextVNode(" Network, sound, battery, and the "),
                          _createElementVNode("strong", null, "Update Manager"),
                          _createTextVNode(" shield icon.")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Files:"),
                          _createTextVNode(" The file manager (Thunar) handles your Documents, Downloads, and USB drives.")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Settings:"),
                          _createTextVNode(" Open "),
                          _createElementVNode("strong", null, "Menu → Settings → Settings Manager"),
                          _createTextVNode(" to customize anything about your system.")
                        ])
                      ], -1)),
                      _cache[58] || (_cache[58] = _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "First Things to Do", -1)),
                      _cache[59] || (_cache[59] = _createElementVNode("ol", { style: {"margin-top":"1rem"} }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Connect to Wi-Fi:"),
                          _createTextVNode(" Click the network icon in the system tray and pick your network.")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Install updates:"),
                          _createTextVNode(" Click the shield icon in the system tray to open "),
                          _createElementVNode("strong", null, "Update Manager"),
                          _createTextVNode(", then click "),
                          _createElementVNode("strong", null, "Install Updates"),
                          _createTextVNode(". Do this first — it keeps your laptop secure.")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Change your password:"),
                          _createTextVNode(" See the "),
                          _createElementVNode("em", null, "Setting the Username"),
                          _createTextVNode(" guide on the previous page.")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Explore the Welcome Screen:"),
                          _createTextVNode(" Linux Mint's Welcome Screen has a guided first-steps tour. Find it in the menu by searching for \"Welcome\".")
                        ])
                      ], -1)),
                      _cache[60] || (_cache[60] = _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Tutorials & Official Guides", -1)),
                      _cache[61] || (_cache[61] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Linux Mint publishes a complete, beginner-friendly user guide. It covers the desktop, software, updates, and troubleshooting:", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("button", {
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (openExternal('https://linuxmint.com/documentation.php'))),
                          class: "btn btn-primary",
                          style: {"font-size":"1.1rem"}
                        }, [...(_cache[51] || (_cache[51] = [
                          _createTextVNode(" Linux Mint User Guide ", -1),
                          _createElementVNode("span", { style: {"margin-left":"0.5rem"} }, "→", -1)
                        ]))])
                      ]),
                      _cache[62] || (_cache[62] = _createElementVNode("div", {
                        class: "info-box info",
                        style: {"margin-top":"2rem"}
                      }, [
                        _createElementVNode("strong", null, "Need Help?"),
                        _createTextVNode(" If you have questions or run into issues, email us at "),
                        _createElementVNode("a", { href: "mailto:info@spacecoaststem.org" }, "info@spacecoaststem.org"),
                        _createTextVNode(" with \"Tech Support\" in the subject line. ")
                      ], -1))
                    ]),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'mintUsername')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[65] || (_cache[65] = _createElementVNode("h2", null, "Setting the Username", -1)),
                    _cache[66] || (_cache[66] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Follow these steps to change your display name and password in Linux Mint (Xfce):", -1)),
                    _cache[67] || (_cache[67] = _createElementVNode("div", { style: {"margin-top":"2rem"} }, [
                      _createElementVNode("h3", null, "Step 1: Open Users and Groups"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click the "),
                          _createElementVNode("strong", null, "Menu"),
                          _createTextVNode(" button in the bottom-left corner of your screen")
                        ]),
                        _createElementVNode("li", null, [
                          _createTextVNode("Type "),
                          _createElementVNode("strong", null, "Users"),
                          _createTextVNode(" in the search box")
                        ]),
                        _createElementVNode("li", null, [
                          _createTextVNode("Click on "),
                          _createElementVNode("strong", null, "Users and Groups"),
                          _createTextVNode(" (it also lives under the "),
                          _createElementVNode("strong", null, "Administration"),
                          _createTextVNode(" category)")
                        ]),
                        _createElementVNode("li", null, "Enter your password when prompted — this tool needs administrator access")
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Step 2: Select Your Account"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, "You'll see a list of accounts on the laptop"),
                        _createElementVNode("li", null, "Click on your own account to select it")
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Step 3: Change Your Display Name"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click on the "),
                          _createElementVNode("strong", null, "name"),
                          _createTextVNode(" shown next to the account picture")
                        ]),
                        _createElementVNode("li", null, "Type your new display name (this is what appears on the login screen)"),
                        _createElementVNode("li", null, [
                          _createTextVNode("Press "),
                          _createElementVNode("strong", null, "Enter"),
                          _createTextVNode(" to save")
                        ])
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Step 4: Change Your Password"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click on the "),
                          _createElementVNode("strong", null, "Password"),
                          _createTextVNode(" field for your account")
                        ]),
                        _createElementVNode("li", null, "Enter your new password twice"),
                        _createElementVNode("li", null, "Confirm to save the change")
                      ]),
                      _createElementVNode("div", { class: "info-box success" }, [
                        _createElementVNode("strong", null, "Tip:"),
                        _createTextVNode(" Pick a password you'll remember. Unlike a school account, there's nobody who can reset a forgotten Linux password for you remotely — you'd have to bring the laptop to us. ")
                      ]),
                      _createElementVNode("div", { class: "info-box warning" }, [
                        _createElementVNode("strong", null, "Note:"),
                        _createTextVNode(" To change your actual username (login name), you may need administrator assistance. Contact your teacher or email us for help with this advanced task. ")
                      ])
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'mintInstallSoftware')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _cache[68] || (_cache[68] = _createElementVNode("h2", null, "Installing Software", -1)),
                    _cache[69] || (_cache[69] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Learn how to install new applications on your Linux Mint laptop:", -1)),
                    _cache[70] || (_cache[70] = _createElementVNode("div", { style: {"margin-top":"2rem"} }, [
                      _createElementVNode("h3", null, "Method 1: Using the Software Manager (Recommended)"),
                      _createElementVNode("h4", { style: {"margin-top":"1.5rem"} }, "Step 1: Open Software Manager"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click on the "),
                          _createElementVNode("strong", null, "Menu"),
                          _createTextVNode(" button")
                        ]),
                        _createElementVNode("li", null, [
                          _createTextVNode("Search for and click on "),
                          _createElementVNode("strong", null, "Software Manager")
                        ])
                      ]),
                      _createElementVNode("h4", { style: {"margin-top":"1.5rem"} }, "Step 2: Search for Software"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Use the "),
                          _createElementVNode("strong", null, "Search"),
                          _createTextVNode(" bar at the top")
                        ]),
                        _createElementVNode("li", null, "Type the name of the application you want (e.g., \"GIMP\", \"VLC\", \"LibreOffice\")"),
                        _createElementVNode("li", null, "Browse through the results")
                      ]),
                      _createElementVNode("h4", { style: {"margin-top":"1.5rem"} }, "Step 3: Install the Application"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, "Click on the application you want to install"),
                        _createElementVNode("li", null, "Read the description and check the reviews"),
                        _createElementVNode("li", null, [
                          _createTextVNode("Click the "),
                          _createElementVNode("strong", null, "Install"),
                          _createTextVNode(" button")
                        ]),
                        _createElementVNode("li", null, "Enter your password when prompted"),
                        _createElementVNode("li", null, "Wait for the installation to complete")
                      ]),
                      _createElementVNode("h4", { style: {"margin-top":"1.5rem"} }, "Step 4: Launch Your New Application"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click the "),
                          _createElementVNode("strong", null, "Menu"),
                          _createTextVNode(" button")
                        ]),
                        _createElementVNode("li", null, "Find your newly installed application (or just search for it)"),
                        _createElementVNode("li", null, "Click to launch it")
                      ]),
                      _createElementVNode("div", {
                        class: "info-box info",
                        style: {"margin-top":"1.5rem"}
                      }, [
                        _createElementVNode("strong", null, "Flatpak apps:"),
                        _createTextVNode(" Linux Mint's Software Manager also includes Flatpak apps out of the box. Some programs are listed twice — once from the Linux Mint repositories and once as a Flatpak. Either works; the repository version is usually smaller. ")
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Method 2: Using the Terminal (Advanced)"),
                      _createElementVNode("p", { style: {"margin-top":"1rem"} }, [
                        _createTextVNode("Once you know a package's name, the terminal is the quickest way to install it. Open "),
                        _createElementVNode("strong", null, "Terminal"),
                        _createTextVNode(" from the menu and run:")
                      ]),
                      _createElementVNode("code", { style: {"display":"block","margin-top":"0.5rem","padding":"0.75rem","background":"rgba(0, 0, 0, 0.1)","border-radius":"4px","font-size":"0.95rem"} }, [
                        _createTextVNode("sudo apt update"),
                        _createElementVNode("br"),
                        _createTextVNode("sudo apt install gimp")
                      ]),
                      _createElementVNode("p", { style: {"margin-top":"0.5rem","font-size":"0.9rem","font-style":"italic"} }, [
                        _createTextVNode("Replace "),
                        _createElementVNode("code", null, "gimp"),
                        _createTextVNode(" with whichever package you want. You'll be asked for your password, then to confirm with "),
                        _createElementVNode("code", null, "y"),
                        _createTextVNode(".")
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Keeping Software Updated"),
                      _createElementVNode("p", { style: {"margin-top":"1rem"} }, [
                        _createTextVNode("Click the "),
                        _createElementVNode("strong", null, "shield icon"),
                        _createTextVNode(" in the system tray (bottom-right) to open "),
                        _createElementVNode("strong", null, "Update Manager"),
                        _createTextVNode(", then click "),
                        _createElementVNode("strong", null, "Install Updates"),
                        _createTextVNode(". This updates your whole system and every app you installed through it — there's no need to update programs one by one.")
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Popular Free Applications for Students"),
                      _createElementVNode("ul", { style: {"margin-top":"1rem"} }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "LibreOffice:"),
                          _createTextVNode(" Word processor, spreadsheet, and presentation software (already installed)")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "GIMP:"),
                          _createTextVNode(" Image editing (like Photoshop)")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Inkscape:"),
                          _createTextVNode(" Vector graphics editor")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Blender:"),
                          _createTextVNode(" 3D modeling and animation")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Audacity:"),
                          _createTextVNode(" Audio recording and editing")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "VLC Media Player:"),
                          _createTextVNode(" Play videos and music")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Visual Studio Code:"),
                          _createTextVNode(" Code editor for programming")
                        ])
                      ]),
                      _createElementVNode("div", { class: "info-box warning" }, [
                        _createElementVNode("strong", null, "Note:"),
                        _createTextVNode(" You need administrator privileges to install software. If you're using a student account, ask your parent or teacher for assistance. ")
                      ]),
                      _createElementVNode("div", { class: "info-box success" }, [
                        _createElementVNode("strong", null, "Safety Tip:"),
                        _createTextVNode(" Only install software from the official Software Manager to ensure it's safe and virus-free! ")
                      ])
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'mintOtherQuestions')
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[80] || (_cache[80] = _createElementVNode("h2", null, "Additional Resources", -1)),
                    _cache[81] || (_cache[81] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Can't find what you're looking for? We have additional resources available!", -1)),
                    _createElementVNode("div", _hoisted_18, [
                      _cache[73] || (_cache[73] = _createElementVNode("h3", null, "🌐 Official Linux Mint Documentation", -1)),
                      _cache[74] || (_cache[74] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "The official Linux Mint User Guide provides comprehensive guides, tutorials, and troubleshooting help for all aspects of using Linux Mint.", -1)),
                      _cache[75] || (_cache[75] = _createElementVNode("div", {
                        class: "info-box info",
                        style: {"margin-top":"1.5rem"}
                      }, [
                        _createElementVNode("strong", null, "Topics covered include:"),
                        _createElementVNode("ul", { style: {"margin-top":"0.5rem","margin-bottom":"0"} }, [
                          _createElementVNode("li", null, "Getting started with Linux Mint"),
                          _createElementVNode("li", null, "Customizing your desktop"),
                          _createElementVNode("li", null, "Installing and managing software"),
                          _createElementVNode("li", null, "System settings and preferences"),
                          _createElementVNode("li", null, "Troubleshooting common issues"),
                          _createElementVNode("li", null, "Advanced features and tips")
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (openExternal('https://linuxmint.com/documentation.php'))),
                          class: "btn btn-primary",
                          style: {"font-size":"1.1rem"}
                        }, [...(_cache[71] || (_cache[71] = [
                          _createTextVNode(" Linux Mint User Guide ", -1),
                          _createElementVNode("span", { style: {"margin-left":"0.5rem"} }, "→", -1)
                        ]))]),
                        _createElementVNode("button", {
                          onClick: _cache[21] || (_cache[21] = ($event: any) => (openExternal('https://forums.linuxmint.com/'))),
                          class: "btn btn-secondary",
                          style: {"font-size":"1.1rem"}
                        }, [...(_cache[72] || (_cache[72] = [
                          _createTextVNode(" Community Forums ", -1),
                          _createElementVNode("span", { style: {"margin-left":"0.5rem"} }, "→", -1)
                        ]))])
                      ]),
                      _cache[76] || (_cache[76] = _createElementVNode("p", { style: {"margin-top":"1.5rem"} }, [
                        _createTextVNode("The "),
                        _createElementVNode("strong", null, "community forums"),
                        _createTextVNode(" are a friendly place to search for an answer or ask a question — chances are someone has already hit the same issue.")
                      ], -1)),
                      _cache[77] || (_cache[77] = _createElementVNode("h3", { style: {"margin-top":"2.5rem"} }, "📧 Contact Space Coast STEM", -1)),
                      _cache[78] || (_cache[78] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "If you still need help or have questions specific to your Space Coast STEM laptop:", -1)),
                      _cache[79] || (_cache[79] = _createElementVNode("div", {
                        class: "info-box warning",
                        style: {"margin-top":"1rem"}
                      }, [
                        _createElementVNode("ul", { style: {"margin":"0"} }, [
                          _createElementVNode("li", null, [
                            _createElementVNode("strong", null, "Email:"),
                            _createTextVNode(),
                            _createElementVNode("a", {
                              href: "mailto:info@spacecoaststem.org",
                              style: {"color":"inherit","text-decoration":"underline"}
                            }, "info@spacecoaststem.org")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("strong", null, "Subject Line:"),
                            _createTextVNode(" Include \"Tech Support\" in your email subject")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("strong", null, "Include:"),
                            _createTextVNode(" Your name, school, and a description of the issue")
                          ])
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'gettingStarted')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _cache[82] || (_cache[82] = _createElementVNode("h2", null, "Getting Started with Zorin OS", -1)),
                    _cache[83] || (_cache[83] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Welcome to your new Space Coast STEM laptop! This guide will help you get started with Zorin OS.", -1)),
                    _cache[84] || (_cache[84] = _createElementVNode("div", { style: {"margin-top":"2rem"} }, [
                      _createElementVNode("h3", null, "Default Login Credentials"),
                      _createElementVNode("div", { class: "info-box warning" }, [
                        _createElementVNode("p", { style: {"margin":"0","font-size":"1.1rem"} }, [
                          _createElementVNode("strong", null, "Username:"),
                          _createTextVNode(),
                          _createElementVNode("code", null, "user")
                        ]),
                        _createElementVNode("p", { style: {"margin":"0.5rem 0 0 0","font-size":"1.1rem"} }, [
                          _createElementVNode("strong", null, "Password:"),
                          _createTextVNode(),
                          _createElementVNode("code", null, "password")
                        ])
                      ]),
                      _createElementVNode("p", { style: {"margin-top":"1rem","font-style":"italic","color":"#666"} }, [
                        _createElementVNode("strong", null, "Important:"),
                        _createTextVNode(" For security, we recommend changing your username and password after your first login.")
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Video Tutorial: Zorin OS Basics"),
                      _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Watch this comprehensive video tutorial to learn the basics of using Zorin OS:"),
                      _createElementVNode("div", { style: {"margin-top":"1.5rem","position":"relative","padding-bottom":"56.25%","height":"0","overflow":"hidden","border-radius":"8px"} }, [
                        _createElementVNode("iframe", {
                          style: {"position":"absolute","top":"0","left":"0","width":"100%","height":"100%","border":"none"},
                          src: "https://www.youtube.com/embed/0K43Bxg8MLU?start=1415&si=dDdS7-QabhwWCO16",
                          title: "Getting Started with Zorin OS",
                          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                          allowfullscreen: ""
                        })
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Quick Start Tips"),
                      _createElementVNode("ul", { style: {"margin-top":"1rem"} }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Application Menu:"),
                          _createTextVNode(" Click the grid icon in the bottom-left corner to access all your apps")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Settings:"),
                          _createTextVNode(" Click the gear icon to customize your system")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Files:"),
                          _createTextVNode(" Find all your documents, downloads, and files in the file manager")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Software Center:"),
                          _createTextVNode(" Install new applications from the Software app")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Updates:"),
                          _createTextVNode(" Keep your system secure by installing updates when prompted")
                        ])
                      ]),
                      _createElementVNode("div", { class: "info-box info" }, [
                        _createElementVNode("strong", null, "Need Help?"),
                        _createTextVNode(" If you have questions or run into issues, email us at "),
                        _createElementVNode("a", { href: "mailto:info@spacecoaststem.org" }, "info@spacecoaststem.org"),
                        _createTextVNode(" with \"Tech Support\" in the subject line. ")
                      ])
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'username')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _cache[85] || (_cache[85] = _createElementVNode("h2", null, "Setting the Username", -1)),
                    _cache[86] || (_cache[86] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Follow these steps to change your username and display name in Zorin OS:", -1)),
                    _cache[87] || (_cache[87] = _createElementVNode("div", { style: {"margin-top":"2rem"} }, [
                      _createElementVNode("h3", null, "Step 1: Open System Settings"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click on the "),
                          _createElementVNode("strong", null, "Menu"),
                          _createTextVNode(" button in the bottom-left corner of your screen")
                        ]),
                        _createElementVNode("li", null, [
                          _createTextVNode("Click on "),
                          _createElementVNode("strong", null, "Settings"),
                          _createTextVNode(" (the gear icon)")
                        ])
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Step 2: Navigate to Users"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("In the Settings window, click on "),
                          _createElementVNode("strong", null, "Users"),
                          _createTextVNode(" in the left sidebar")
                        ]),
                        _createElementVNode("li", null, "You'll see your current user account displayed")
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Step 3: Unlock Settings"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click the "),
                          _createElementVNode("strong", null, "Unlock"),
                          _createTextVNode(" button in the top-right corner")
                        ]),
                        _createElementVNode("li", null, "Enter your password when prompted")
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Step 4: Change Your Name"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click on your "),
                          _createElementVNode("strong", null, "Full Name"),
                          _createTextVNode(" field")
                        ]),
                        _createElementVNode("li", null, "Type your new display name (this is what appears on the login screen)"),
                        _createElementVNode("li", null, [
                          _createTextVNode("Press "),
                          _createElementVNode("strong", null, "Enter"),
                          _createTextVNode(" to save")
                        ])
                      ]),
                      _createElementVNode("div", { class: "info-box warning" }, [
                        _createElementVNode("strong", null, "Note:"),
                        _createTextVNode(" To change your actual username (login name), you may need administrator assistance. Contact your teacher or email us for help with this advanced task. ")
                      ])
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'parentalControl')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _cache[88] || (_cache[88] = _createElementVNode("h2", null, "Adding a User for Parental Controls", -1)),
                    _cache[89] || (_cache[89] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Create a new user account with restricted access and parental controls:", -1)),
                    _cache[90] || (_cache[90] = _createElementVNode("div", { style: {"margin-top":"2rem"} }, [
                      _createElementVNode("h3", null, "Step 1: Open System Settings"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click on the "),
                          _createElementVNode("strong", null, "Menu"),
                          _createTextVNode(" button in the bottom-left corner")
                        ]),
                        _createElementVNode("li", null, [
                          _createTextVNode("Open "),
                          _createElementVNode("strong", null, "Settings")
                        ])
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Step 2: Go to Users"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click on "),
                          _createElementVNode("strong", null, "Users"),
                          _createTextVNode(" in the left sidebar")
                        ]),
                        _createElementVNode("li", null, [
                          _createTextVNode("Click the "),
                          _createElementVNode("strong", null, "Unlock"),
                          _createTextVNode(" button and enter your password")
                        ])
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Step 3: Add New User"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click the "),
                          _createElementVNode("strong", null, "Add User"),
                          _createTextVNode(" button (+ icon)")
                        ]),
                        _createElementVNode("li", null, [
                          _createTextVNode("Choose "),
                          _createElementVNode("strong", null, "Standard"),
                          _createTextVNode(" account type (not Administrator)")
                        ]),
                        _createElementVNode("li", null, [
                          _createTextVNode("Enter the "),
                          _createElementVNode("strong", null, "Full Name"),
                          _createTextVNode(" for the new user")
                        ]),
                        _createElementVNode("li", null, [
                          _createTextVNode("Enter a "),
                          _createElementVNode("strong", null, "Username"),
                          _createTextVNode(" (no spaces, lowercase)")
                        ])
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Step 4: Set Password"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Choose "),
                          _createElementVNode("strong", null, "\"Set a password now\"")
                        ]),
                        _createElementVNode("li", null, "Enter a secure password twice"),
                        _createElementVNode("li", null, [
                          _createTextVNode("Click "),
                          _createElementVNode("strong", null, "Add"),
                          _createTextVNode(" to create the account")
                        ])
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Step 5: Configure Parental Controls"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, "Select the newly created user account"),
                        _createElementVNode("li", null, [
                          _createTextVNode("Click on "),
                          _createElementVNode("strong", null, "Parental Controls"),
                          _createTextVNode(" (if available)")
                        ]),
                        _createElementVNode("li", null, "Set restrictions for application usage, web browsing, and time limits")
                      ]),
                      _createElementVNode("div", { class: "info-box info" }, [
                        _createElementVNode("strong", null, "Tip:"),
                        _createTextVNode(" Standard user accounts cannot install software or change system settings, providing a safer environment for younger users. ")
                      ])
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'installSoftware')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _cache[91] || (_cache[91] = _createElementVNode("h2", null, "Installing Software", -1)),
                    _cache[92] || (_cache[92] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Learn how to install new applications on your Zorin OS laptop:", -1)),
                    _cache[93] || (_cache[93] = _createElementVNode("div", { style: {"margin-top":"2rem"} }, [
                      _createElementVNode("h3", null, "Method 1: Using the Software Center (Recommended)"),
                      _createElementVNode("h4", { style: {"margin-top":"1.5rem"} }, "Step 1: Open Software Center"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click on the "),
                          _createElementVNode("strong", null, "Menu"),
                          _createTextVNode(" button")
                        ]),
                        _createElementVNode("li", null, [
                          _createTextVNode("Search for and click on "),
                          _createElementVNode("strong", null, "Software")
                        ])
                      ]),
                      _createElementVNode("h4", { style: {"margin-top":"1.5rem"} }, "Step 2: Search for Software"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Use the "),
                          _createElementVNode("strong", null, "Search"),
                          _createTextVNode(" bar at the top")
                        ]),
                        _createElementVNode("li", null, "Type the name of the application you want (e.g., \"GIMP\", \"VLC\", \"LibreOffice\")"),
                        _createElementVNode("li", null, "Browse through the results")
                      ]),
                      _createElementVNode("h4", { style: {"margin-top":"1.5rem"} }, "Step 3: Install the Application"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, "Click on the application you want to install"),
                        _createElementVNode("li", null, "Read the description and check the reviews"),
                        _createElementVNode("li", null, [
                          _createTextVNode("Click the "),
                          _createElementVNode("strong", null, "Install"),
                          _createTextVNode(" button")
                        ]),
                        _createElementVNode("li", null, "Enter your password when prompted"),
                        _createElementVNode("li", null, "Wait for the installation to complete")
                      ]),
                      _createElementVNode("h4", { style: {"margin-top":"1.5rem"} }, "Step 4: Launch Your New Application"),
                      _createElementVNode("ol", null, [
                        _createElementVNode("li", null, [
                          _createTextVNode("Click the "),
                          _createElementVNode("strong", null, "Menu"),
                          _createTextVNode(" button")
                        ]),
                        _createElementVNode("li", null, "Find your newly installed application"),
                        _createElementVNode("li", null, "Click to launch it")
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Popular Free Applications for Students"),
                      _createElementVNode("ul", { style: {"margin-top":"1rem"} }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "LibreOffice:"),
                          _createTextVNode(" Word processor, spreadsheet, and presentation software")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "GIMP:"),
                          _createTextVNode(" Image editing (like Photoshop)")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Inkscape:"),
                          _createTextVNode(" Vector graphics editor")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Blender:"),
                          _createTextVNode(" 3D modeling and animation")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Audacity:"),
                          _createTextVNode(" Audio recording and editing")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "VLC Media Player:"),
                          _createTextVNode(" Play videos and music")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Visual Studio Code:"),
                          _createTextVNode(" Code editor for programming")
                        ])
                      ]),
                      _createElementVNode("div", { class: "info-box warning" }, [
                        _createElementVNode("strong", null, "Note:"),
                        _createTextVNode(" You need administrator privileges to install software. If you're using a student account, ask your parent or teacher for assistance. ")
                      ]),
                      _createElementVNode("div", { class: "info-box success" }, [
                        _createElementVNode("strong", null, "Safety Tip:"),
                        _createTextVNode(" Only install software from the official Software Center to ensure it's safe and virus-free! ")
                      ])
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'popularPackages')
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _cache[116] || (_cache[116] = _createElementVNode("h2", null, "Popular Free Software for Students", -1)),
                    _cache[117] || (_cache[117] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, [
                      _createTextVNode("Discover powerful free and open-source applications perfect for education, creativity, and productivity. All of these can be installed from your app store — the "),
                      _createElementVNode("strong", null, "Software Manager"),
                      _createTextVNode(" on Linux Mint, or the "),
                      _createElementVNode("strong", null, "Software Center"),
                      _createTextVNode(" on Zorin OS!")
                    ], -1)),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[110] || (_cache[110] = _createElementVNode("h3", null, "🎨 Creative & Design", -1)),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[22] || (_cache[22] = ($event: any) => (openExternal('https://www.gimp.org/')))
                        }, [...(_cache[94] || (_cache[94] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/gimp.png",
                            alt: "GIMP",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "GIMP", -1),
                          _createElementVNode("p", null, "Professional photo editing and image manipulation (like Photoshop)", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (openExternal('https://inkscape.org/')))
                        }, [...(_cache[95] || (_cache[95] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/inkscape.png",
                            alt: "Inkscape",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "Inkscape", -1),
                          _createElementVNode("p", null, "Vector graphics editor for logos, illustrations, and design", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (openExternal('https://www.blender.org/')))
                        }, [...(_cache[96] || (_cache[96] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/blender.png",
                            alt: "Blender",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "Blender", -1),
                          _createElementVNode("p", null, "3D modeling, animation, rendering, and game development", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (openExternal('https://krita.org/')))
                        }, [...(_cache[97] || (_cache[97] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/krita.png",
                            alt: "Krita",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "Krita", -1),
                          _createElementVNode("p", null, "Digital painting and illustration for artists", -1)
                        ]))])
                      ]),
                      _cache[111] || (_cache[111] = _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "📝 Office & Productivity", -1)),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[26] || (_cache[26] = ($event: any) => (openExternal('https://www.libreoffice.org/')))
                        }, [...(_cache[98] || (_cache[98] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/libreoffice.png",
                            alt: "LibreOffice",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "LibreOffice", -1),
                          _createElementVNode("p", null, "Complete office suite - Writer, Calc, Impress, and more", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (openExternal('https://obsidian.md/')))
                        }, [...(_cache[99] || (_cache[99] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/obsidian.png",
                            alt: "Obsidian",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "Obsidian", -1),
                          _createElementVNode("p", null, "Knowledge base and note-taking with markdown support", -1)
                        ]))])
                      ]),
                      _cache[112] || (_cache[112] = _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "💻 Programming & Development", -1)),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[28] || (_cache[28] = ($event: any) => (openExternal('https://code.visualstudio.com/')))
                        }, [...(_cache[100] || (_cache[100] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/vscode.png",
                            alt: "VS Code",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "Visual Studio Code", -1),
                          _createElementVNode("p", null, "Powerful code editor with extensions for any language", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[29] || (_cache[29] = ($event: any) => (openExternal('https://www.python.org/')))
                        }, [...(_cache[101] || (_cache[101] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/python.png",
                            alt: "Python",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "Python", -1),
                          _createElementVNode("p", null, "Popular programming language for beginners and professionals", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[30] || (_cache[30] = ($event: any) => (openExternal('https://scratch.mit.edu/')))
                        }, [...(_cache[102] || (_cache[102] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/scratch.png",
                            alt: "Scratch",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "Scratch", -1),
                          _createElementVNode("p", null, "Visual programming language perfect for learning to code", -1)
                        ]))])
                      ]),
                      _cache[113] || (_cache[113] = _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "⚙️ Engineering & CAD", -1)),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[31] || (_cache[31] = ($event: any) => (openExternal('https://www.freecad.org/')))
                        }, [...(_cache[103] || (_cache[103] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/freecad.png",
                            alt: "FreeCAD",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "FreeCAD", -1),
                          _createElementVNode("p", null, "Parametric 3D modeling for mechanical engineering and design", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[32] || (_cache[32] = ($event: any) => (openExternal('https://www.kicad.org/')))
                        }, [...(_cache[104] || (_cache[104] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/kicad.png",
                            alt: "KiCad",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "KiCad", -1),
                          _createElementVNode("p", null, "Electronics design automation for PCB design and schematics", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[33] || (_cache[33] = ($event: any) => (openExternal('https://fritzing.org/')))
                        }, [...(_cache[105] || (_cache[105] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/fritzing.png",
                            alt: "Fritzing",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "Fritzing", -1),
                          _createElementVNode("p", null, "Electronics prototyping and circuit design for Arduino projects", -1)
                        ]))])
                      ]),
                      _cache[114] || (_cache[114] = _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "🎬 Media & Entertainment", -1)),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[34] || (_cache[34] = ($event: any) => (openExternal('https://www.videolan.org/vlc/')))
                        }, [...(_cache[106] || (_cache[106] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/vlc.png",
                            alt: "VLC",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "VLC Media Player", -1),
                          _createElementVNode("p", null, "Play any video or audio format", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[35] || (_cache[35] = ($event: any) => (openExternal('https://www.audacityteam.org/')))
                        }, [...(_cache[107] || (_cache[107] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/audacity.png",
                            alt: "Audacity",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "Audacity", -1),
                          _createElementVNode("p", null, "Record and edit audio files", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[36] || (_cache[36] = ($event: any) => (openExternal('https://obsproject.com/')))
                        }, [...(_cache[108] || (_cache[108] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/obs.png",
                            alt: "OBS Studio",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "OBS Studio", -1),
                          _createElementVNode("p", null, "Screen recording and live streaming software", -1)
                        ]))]),
                        _createElementVNode("div", {
                          class: "package-card",
                          onClick: _cache[37] || (_cache[37] = ($event: any) => (openExternal('https://kdenlive.org/')))
                        }, [...(_cache[109] || (_cache[109] = [
                          _createElementVNode("img", {
                            src: "/assets/img/logos/kdenlive.png",
                            alt: "Kdenlive",
                            class: "package-logo"
                          }, null, -1),
                          _createElementVNode("h4", null, "Kdenlive", -1),
                          _createElementVNode("p", null, "Video editing with professional features", -1)
                        ]))])
                      ]),
                      _cache[115] || (_cache[115] = _createElementVNode("div", {
                        class: "info-box info",
                        style: {"margin-top":"2rem"}
                      }, [
                        _createElementVNode("strong", null, "How to Install:"),
                        _createTextVNode(" Open the "),
                        _createElementVNode("strong", null, "Software Manager"),
                        _createTextVNode(" (Linux Mint) or "),
                        _createElementVNode("strong", null, "Software Center"),
                        _createTextVNode(" (Zorin OS) from your menu, search for the application name, and click "),
                        _createElementVNode("strong", null, "Install"),
                        _createTextVNode(". Most of these apps are completely free and open-source! ")
                      ], -1))
                    ]),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'whyLinux')
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _cache[118] || (_cache[118] = _createElementVNode("h2", null, "Why We Choose Linux", -1)),
                    _cache[119] || (_cache[119] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, [
                      _createTextVNode("At Space Coast STEM, we install Linux (specifically "),
                      _createElementVNode("a", {
                        href: "https://linuxmint.com/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        style: {"color":"var(--secondary-color)","text-decoration":"underline"}
                      }, "Linux Mint"),
                      _createTextVNode(" with the Xfce desktop) on all refurbished machines unless there are special circumstances or requests. Here's why this decision benefits students, schools, and the environment.")
                    ], -1)),
                    _cache[120] || (_cache[120] = _createElementVNode("div", { style: {"margin-top":"2rem"} }, [
                      _createElementVNode("h3", null, "Why Linux?"),
                      _createElementVNode("div", { class: "benefit-item" }, [
                        _createElementVNode("h4", null, "⚡ Superior Performance"),
                        _createElementVNode("p", null, "Linux is engineered for efficiency. While Windows and macOS have become increasingly resource-heavy, Linux delivers fast, responsive performance on both new and older hardware. Students get a modern operating system that runs smoothly without the distraction of unwanted ads and newsfeeds.")
                      ]),
                      _createElementVNode("div", { class: "benefit-item" }, [
                        _createElementVNode("h4", null, "♻️ Sustainable Technology"),
                        _createElementVNode("p", null, "Linux's efficient design means hardware stays capable and relevant longer. Machines that might be considered \"too old\" for the latest Windows or macOS continue to run modern Linux perfectly, reducing e-waste while giving students fully functional, contemporary computers.")
                      ]),
                      _createElementVNode("div", { class: "benefit-item" }, [
                        _createElementVNode("h4", null, "🆓 Zero Licensing Costs"),
                        _createElementVNode("p", null, "Linux is completely free and open source. We don't have to pay for operating system licenses when refurbishing laptops, which means more resources can go directly toward helping students rather than software licensing fees.")
                      ]),
                      _createElementVNode("div", { class: "benefit-item" }, [
                        _createElementVNode("h4", null, "🔧 Professional-Grade Software Ecosystem"),
                        _createElementVNode("p", null, "Linux provides access to thousands of powerful, professional applications—all free. From development tools to creative suites to productivity software, students get the same industry-standard tools used by developers, engineers, and professionals worldwide, without any licensing costs.")
                      ]),
                      _createElementVNode("div", { class: "benefit-item" }, [
                        _createElementVNode("h4", null, "💼 Industry-Standard Technology"),
                        _createElementVNode("p", null, "Linux powers the modern world. It runs the majority of web servers, all supercomputers, cloud infrastructure, and smartphones (Android). By using Linux, students gain hands-on experience with the same operating system that drives global technology, from NASA to Google to Amazon.")
                      ]),
                      _createElementVNode("div", { class: "benefit-item" }, [
                        _createElementVNode("h4", null, "🎓 Real-World Technical Experience"),
                        _createElementVNode("p", null, "Using Linux teaches students problem-solving, technical literacy, and how professional computing environments work. These are transferable skills that benefit any STEM career path, from software engineering to data science to cybersecurity.")
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "Why Linux Mint (Xfce) Specifically?"),
                      _createElementVNode("p", { style: {"margin-top":"1rem"} }, [
                        _createTextVNode("We install "),
                        _createElementVNode("strong", null, "Linux Mint"),
                        _createTextVNode(" with the "),
                        _createElementVNode("strong", null, "Xfce"),
                        _createTextVNode(" desktop on the laptops we refurbish today:")
                      ]),
                      _createElementVNode("ul", { style: {"margin-top":"1rem"} }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Familiar, Intuitive Interface:"),
                          _createTextVNode(" A traditional menu and taskbar layout that anyone coming from Windows can use immediately")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Lightweight and Fast:"),
                          _createTextVNode(" Xfce uses very little memory, so the older laptops we refurbish stay genuinely quick")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Rock-Solid and Well Supported:"),
                          _createTextVNode(" Built on Ubuntu LTS with years of security updates, and one of the largest beginner communities in Linux")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Simple, Safe Software Installs:"),
                          _createTextVNode(" The Software Manager bundles repository and Flatpak apps in one place, and Update Manager keeps everything current in one click")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Extensive Software Library:"),
                          _createTextVNode(" Access to thousands of free, professional applications")
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("strong", null, "Excellent Documentation:"),
                          _createTextVNode(" A clear, beginner-friendly official user guide students and parents can follow on their own")
                        ])
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2rem"} }, "What About Zorin OS?"),
                      _createElementVNode("p", { style: {"margin-top":"1rem"} }, [
                        _createTextVNode("We previously used "),
                        _createElementVNode("a", {
                          href: "https://zorin.com/os/education/",
                          target: "_blank",
                          rel: "noopener noreferrer",
                          style: {"color":"var(--secondary-color)","text-decoration":"underline"}
                        }, "Zorin OS"),
                        _createTextVNode(", and a number of students still have laptops running it. Those machines are "),
                        _createElementVNode("strong", null, "still fully supported"),
                        _createTextVNode(" — you don't need to change anything, and we keep the Zorin OS guides on this site up to date. We standardized on Linux Mint Xfce going forward because it runs lighter on the older hardware we refurbish and has a larger pool of community documentation for students to lean on.")
                      ]),
                      _createElementVNode("div", {
                        class: "info-box info",
                        style: {"margin-top":"2rem"}
                      }, [
                        _createElementVNode("strong", null, "What About Windows or Mac?"),
                        _createTextVNode(" Linux provides the best experience for most students, combining professional capabilities with excellent performance. However, if you have specific software requirements that require Windows or macOS, we're happy to discuss alternatives. Just "),
                        _createElementVNode("a", {
                          href: "/contact",
                          style: {"color":"inherit","text-decoration":"underline"}
                        }, "contact us"),
                        _createTextVNode(" with your specific needs. ")
                      ])
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'gaming')
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _cache[121] || (_cache[121] = _createElementVNode("h2", null, "Gaming on Linux", -1)),
                    _cache[122] || (_cache[122] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "While these laptops are primarily for school work, we believe students should be able to explore their interests and passions. Many people get into computer science through an interest in games—whether playing, developing, or modding them. Gaming can be a gateway to learning programming, 3D modeling, game design, and much more!", -1)),
                    _cache[123] || (_cache[123] = _createElementVNode("div", { style: {"margin-top":"2rem"} }, [
                      _createElementVNode("h3", null, "🎮 Playing Games on Linux"),
                      _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Linux has come a long way for gaming. Here are two great gaming options you can install on your laptop:"),
                      _createElementVNode("div", { class: "gaming-section" }, [
                        _createElementVNode("h4", { style: {"color":"var(--primary-color, #2c4a6b)","margin-top":"1.5rem"} }, "Sober - Play Roblox on Linux"),
                        _createElementVNode("p", { style: {"margin-top":"0.5rem"} }, "Sober is a runtime that lets you play Roblox on Linux. It's easy to install using Flatpak!"),
                        _createElementVNode("div", {
                          class: "info-box info",
                          style: {"margin-top":"1rem"}
                        }, [
                          _createElementVNode("strong", null, "How to Install Sober:"),
                          _createElementVNode("ol", { style: {"margin-top":"0.5rem"} }, [
                            _createElementVNode("li", null, [
                              _createTextVNode("Open the "),
                              _createElementVNode("strong", null, "Terminal"),
                              _createTextVNode(" application (search for it in the menu)")
                            ]),
                            _createElementVNode("li", null, "Copy and paste this command and press Enter:")
                          ]),
                          _createElementVNode("code", { style: {"display":"block","margin-top":"0.5rem","padding":"0.75rem","background":"rgba(0, 0, 0, 0.1)","border-radius":"4px","font-size":"0.95rem"} }, "flatpak install flathub org.vinegarhq.Sober"),
                          _createElementVNode("ol", {
                            start: "3",
                            style: {"margin-top":"0.5rem"}
                          }, [
                            _createElementVNode("li", null, [
                              _createTextVNode("Type "),
                              _createElementVNode("code", null, "y"),
                              _createTextVNode(" and press Enter when asked to confirm")
                            ]),
                            _createElementVNode("li", null, "Wait for the installation to complete"),
                            _createElementVNode("li", null, "Once installed, you can find Sober in your application menu!")
                          ])
                        ]),
                        _createElementVNode("h4", { style: {"color":"var(--primary-color, #2c4a6b)","margin-top":"2rem"} }, "Luanti (Minetest) - Open Source Voxel Game"),
                        _createElementVNode("p", { style: {"margin-top":"0.5rem"} }, "Luanti (formerly known as Minetest) is a free and open-source voxel game engine similar to Minecraft. It supports user-created games, mods, and has an active community!"),
                        _createElementVNode("div", {
                          class: "info-box info",
                          style: {"margin-top":"1rem"}
                        }, [
                          _createElementVNode("strong", null, "How to Install Luanti:"),
                          _createElementVNode("ol", { style: {"margin-top":"0.5rem"} }, [
                            _createElementVNode("li", null, [
                              _createTextVNode("Open the "),
                              _createElementVNode("strong", null, "Software Manager"),
                              _createTextVNode(" (Linux Mint) or "),
                              _createElementVNode("strong", null, "Software Center"),
                              _createTextVNode(" (Zorin OS) from your menu")
                            ]),
                            _createElementVNode("li", null, [
                              _createTextVNode("Search for "),
                              _createElementVNode("strong", null, "\"Minetest\""),
                              _createTextVNode(" or "),
                              _createElementVNode("strong", null, "\"Luanti\"")
                            ]),
                            _createElementVNode("li", null, [
                              _createTextVNode("Click "),
                              _createElementVNode("strong", null, "Install")
                            ]),
                            _createElementVNode("li", null, "Enter your password when prompted"),
                            _createElementVNode("li", null, "Launch from your application menu and start playing!")
                          ])
                        ]),
                        _createElementVNode("p", { style: {"margin-top":"1rem","font-style":"italic","color":"#666"} }, [
                          _createElementVNode("strong", null, "Why Luanti?"),
                          _createTextVNode(" It's completely free, runs great on older hardware, supports thousands of community-made mods and games, and is an excellent introduction to game modding and development! ")
                        ])
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2.5rem"} }, "🛠️ For Advanced Users: Build Luanti from Source"),
                      _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Ready for a challenge? Building software from source code is an important skill in software development. Here's how to build Luanti yourself and even modify the game!"),
                      _createElementVNode("div", {
                        class: "info-box warning",
                        style: {"margin-top":"1rem"}
                      }, [
                        _createElementVNode("strong", null, "⚠️ Advanced Section:"),
                        _createTextVNode(" This section is for students comfortable with the command line and interested in learning software development. Don't worry if this seems complicated—it's meant to be a learning challenge! ")
                      ]),
                      _createElementVNode("div", { style: {"margin-top":"1.5rem"} }, [
                        _createElementVNode("h4", { style: {"color":"var(--secondary-color, #3ba3d1)"} }, "Step 1: Install Build Dependencies"),
                        _createElementVNode("p", { style: {"margin-top":"0.5rem"} }, "First, we need to install the tools required to build Luanti:"),
                        _createElementVNode("code", { style: {"display":"block","margin-top":"0.5rem","padding":"0.75rem","background":"rgba(0, 0, 0, 0.1)","border-radius":"4px","font-size":"0.9rem"} }, "sudo apt update && sudo apt install -y git build-essential cmake libgmp-dev libjpeg-dev libpng-dev libfreetype6-dev libsqlite3-dev libogg-dev libvorbis-dev libopenal-dev libcurl4-gnutls-dev libluajit-5.1-dev libleveldb-dev libzstd-dev gettext"),
                        _createElementVNode("h4", { style: {"color":"var(--secondary-color, #3ba3d1)","margin-top":"1.5rem"} }, "Step 2: Clone the Luanti Repository"),
                        _createElementVNode("p", { style: {"margin-top":"0.5rem"} }, "Download the Luanti source code from GitHub:"),
                        _createElementVNode("code", { style: {"display":"block","margin-top":"0.5rem","padding":"0.75rem","background":"rgba(0, 0, 0, 0.1)","border-radius":"4px","font-size":"0.9rem"} }, [
                          _createTextVNode("git clone --depth 1 https://github.com/minetest/minetest.git"),
                          _createElementVNode("br"),
                          _createTextVNode("cd minetest")
                        ]),
                        _createElementVNode("h4", { style: {"color":"var(--secondary-color, #3ba3d1)","margin-top":"1.5rem"} }, "Step 3: Build the Game"),
                        _createElementVNode("p", { style: {"margin-top":"0.5rem"} }, "Compile the source code into a working game:"),
                        _createElementVNode("code", { style: {"display":"block","margin-top":"0.5rem","padding":"0.75rem","background":"rgba(0, 0, 0, 0.1)","border-radius":"4px","font-size":"0.9rem"} }, [
                          _createTextVNode("cmake . -DBUILD_CLIENT=1 -DBUILD_SERVER=0"),
                          _createElementVNode("br"),
                          _createTextVNode("make -j$(nproc)")
                        ]),
                        _createElementVNode("p", { style: {"margin-top":"0.5rem","font-size":"0.9rem","font-style":"italic"} }, [
                          _createTextVNode("This will take several minutes. The "),
                          _createElementVNode("code", null, "-j$(nproc)"),
                          _createTextVNode(" flag uses all your CPU cores to build faster!")
                        ]),
                        _createElementVNode("h4", { style: {"color":"var(--secondary-color, #3ba3d1)","margin-top":"1.5rem"} }, "Step 4: Run Your Build"),
                        _createElementVNode("p", { style: {"margin-top":"0.5rem"} }, "Start the game you just compiled:"),
                        _createElementVNode("code", { style: {"display":"block","margin-top":"0.5rem","padding":"0.75rem","background":"rgba(0, 0, 0, 0.1)","border-radius":"4px","font-size":"0.9rem"} }, "./bin/minetest")
                      ]),
                      _createElementVNode("h3", { style: {"margin-top":"2.5rem"} }, "🎯 Challenges for Advanced Users"),
                      _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Now that you've built Luanti, try these coding challenges to modify the game:"),
                      _createElementVNode("div", {
                        class: "challenge-list",
                        style: {"margin-top":"1rem"}
                      }, [
                        _createElementVNode("div", {
                          class: "challenge-item",
                          style: {"background":"#f8f9fa","padding":"1rem","border-radius":"6px","margin-bottom":"1rem","border-left":"4px solid var(--secondary-color, #3ba3d1)"}
                        }, [
                          _createElementVNode("h4", { style: {"margin":"0 0 0.5rem 0","color":"var(--primary-color, #2c4a6b)"} }, "Challenge 1: Change the Window Title"),
                          _createElementVNode("p", { style: {"margin":"0","font-size":"0.95rem"} }, "Find and modify the code that sets the game window title. Make it display your name or a custom message!"),
                          _createElementVNode("p", { style: {"margin":"0.5rem 0 0 0","font-size":"0.85rem","font-style":"italic","color":"#666"} }, [
                            _createTextVNode("Hint: Look in the "),
                            _createElementVNode("code", null, "src/client/clientlauncher.cpp"),
                            _createTextVNode(" file")
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "challenge-item",
                          style: {"background":"#f8f9fa","padding":"1rem","border-radius":"6px","margin-bottom":"1rem","border-left":"4px solid var(--secondary-color, #3ba3d1)"}
                        }, [
                          _createElementVNode("h4", { style: {"margin":"0 0 0.5rem 0","color":"var(--primary-color, #2c4a6b)"} }, "Challenge 2: Modify Player Speed"),
                          _createElementVNode("p", { style: {"margin":"0","font-size":"0.95rem"} }, "Find the player movement code and increase the walking speed by 50%. How does this change the gameplay?"),
                          _createElementVNode("p", { style: {"margin":"0.5rem 0 0 0","font-size":"0.85rem","font-style":"italic","color":"#666"} }, [
                            _createTextVNode("Hint: Search for movement-related constants in "),
                            _createElementVNode("code", null, "src/"),
                            _createTextVNode(" directory")
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "challenge-item",
                          style: {"background":"#f8f9fa","padding":"1rem","border-radius":"6px","margin-bottom":"1rem","border-left":"4px solid var(--secondary-color, #3ba3d1)"}
                        }, [
                          _createElementVNode("h4", { style: {"margin":"0 0 0.5rem 0","color":"var(--primary-color, #2c4a6b)"} }, "Challenge 3: Create a Custom Block Type"),
                          _createElementVNode("p", { style: {"margin":"0","font-size":"0.95rem"} }, "Add a completely new block type to the game with unique properties. Research how blocks are defined in the Luanti source code!"),
                          _createElementVNode("p", { style: {"margin":"0.5rem 0 0 0","font-size":"0.85rem","font-style":"italic","color":"#666"} }, [
                            _createTextVNode("Hint: Start by examining the built-in games in the "),
                            _createElementVNode("code", null, "games/"),
                            _createTextVNode(" directory")
                          ])
                        ]),
                        _createElementVNode("div", {
                          class: "challenge-item",
                          style: {"background":"#f8f9fa","padding":"1rem","border-radius":"6px","border-left":"4px solid var(--secondary-color, #3ba3d1)"}
                        }, [
                          _createElementVNode("h4", { style: {"margin":"0 0 0.5rem 0","color":"var(--primary-color, #2c4a6b)"} }, "Challenge 4: Add Debug Messages"),
                          _createElementVNode("p", { style: {"margin":"0","font-size":"0.95rem"} }, "Add console debug output that prints your position every second. This teaches you about the game loop and debugging!"),
                          _createElementVNode("p", { style: {"margin":"0.5rem 0 0 0","font-size":"0.85rem","font-style":"italic","color":"#666"} }, [
                            _createTextVNode("Hint: Use "),
                            _createElementVNode("code", null, "infostream"),
                            _createTextVNode(" or "),
                            _createElementVNode("code", null, "errorstream"),
                            _createTextVNode(" for console output")
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "info-box success",
                        style: {"margin-top":"2rem"}
                      }, [
                        _createElementVNode("strong", null, "🌟 Learning Outcomes:"),
                        _createTextVNode(" By building and modifying Luanti, you'll learn: "),
                        _createElementVNode("ul", { style: {"margin-top":"0.5rem","margin-bottom":"0"} }, [
                          _createElementVNode("li", null, "How to use Git and GitHub for source code management"),
                          _createElementVNode("li", null, "The C++ programming language and CMake build system"),
                          _createElementVNode("li", null, "How game engines work under the hood"),
                          _createElementVNode("li", null, "Reading and navigating large codebases"),
                          _createElementVNode("li", null, "The software development workflow used by professionals")
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "info-box info",
                        style: {"margin-top":"1rem"}
                      }, [
                        _createElementVNode("strong", null, "📖 Resources:"),
                        _createElementVNode("ul", { style: {"margin-top":"0.5rem","margin-bottom":"0"} }, [
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "https://github.com/minetest/minetest",
                              target: "_blank",
                              rel: "noopener noreferrer",
                              style: {"color":"inherit","text-decoration":"underline"}
                            }, "Luanti GitHub Repository")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "https://wiki.minetest.net/Main_Page",
                              target: "_blank",
                              rel: "noopener noreferrer",
                              style: {"color":"inherit","text-decoration":"underline"}
                            }, "Luanti Wiki & Modding Guides")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "https://dev.luanti.org/",
                              target: "_blank",
                              rel: "noopener noreferrer",
                              style: {"color":"inherit","text-decoration":"underline"}
                            }, "Luanti Developer Documentation")
                          ])
                        ])
                      ])
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true),
              (activeModal.value === 'otherQuestions')
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _cache[131] || (_cache[131] = _createElementVNode("h2", null, "Additional Resources", -1)),
                    _cache[132] || (_cache[132] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "Can't find what you're looking for? We have additional resources available!", -1)),
                    _createElementVNode("div", _hoisted_34, [
                      _cache[125] || (_cache[125] = _createElementVNode("h3", null, "🌐 Official Zorin OS Help Center", -1)),
                      _cache[126] || (_cache[126] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "The official Zorin OS documentation provides comprehensive guides, tutorials, and troubleshooting help for all aspects of using Zorin OS.", -1)),
                      _cache[127] || (_cache[127] = _createElementVNode("div", {
                        class: "info-box info",
                        style: {"margin-top":"1.5rem"}
                      }, [
                        _createElementVNode("strong", null, "Topics covered include:"),
                        _createElementVNode("ul", { style: {"margin-top":"0.5rem","margin-bottom":"0"} }, [
                          _createElementVNode("li", null, "Getting started with Zorin OS"),
                          _createElementVNode("li", null, "Customizing your desktop"),
                          _createElementVNode("li", null, "Installing and managing software"),
                          _createElementVNode("li", null, "System settings and preferences"),
                          _createElementVNode("li", null, "Troubleshooting common issues"),
                          _createElementVNode("li", null, "Advanced features and tips")
                        ])
                      ], -1)),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("button", {
                          onClick: _cache[38] || (_cache[38] = ($event: any) => (openExternal('https://help.zorin.com'))),
                          class: "btn btn-primary",
                          style: {"font-size":"1.1rem"}
                        }, [...(_cache[124] || (_cache[124] = [
                          _createTextVNode(" Visit Zorin Help Center ", -1),
                          _createElementVNode("span", { style: {"margin-left":"0.5rem"} }, "→", -1)
                        ]))])
                      ]),
                      _cache[128] || (_cache[128] = _createElementVNode("h3", { style: {"margin-top":"2.5rem"} }, "📧 Contact Space Coast STEM", -1)),
                      _cache[129] || (_cache[129] = _createElementVNode("p", { style: {"margin-top":"1rem"} }, "If you still need help or have questions specific to your Space Coast STEM laptop:", -1)),
                      _cache[130] || (_cache[130] = _createElementVNode("div", {
                        class: "info-box warning",
                        style: {"margin-top":"1rem"}
                      }, [
                        _createElementVNode("ul", { style: {"margin":"0"} }, [
                          _createElementVNode("li", null, [
                            _createElementVNode("strong", null, "Email:"),
                            _createTextVNode(),
                            _createElementVNode("a", {
                              href: "mailto:info@spacecoaststem.org",
                              style: {"color":"inherit","text-decoration":"underline"}
                            }, "info@spacecoaststem.org")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("strong", null, "Subject Line:"),
                            _createTextVNode(" Include \"Tech Support\" in your email subject")
                          ]),
                          _createElementVNode("li", null, [
                            _createElementVNode("strong", null, "Include:"),
                            _createTextVNode(" Your name, school, and a description of the issue")
                          ])
                        ])
                      ], -1))
                    ]),
                    _createElementVNode("button", {
                      onClick: closeModal,
                      class: "btn btn-primary",
                      style: {"margin-top":"2rem"}
                    }, "Close")
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})